import nvSharedServicesUtilsModule from '../../shared/services/utilities/nv.shared.services.utils.module';

angular.module('nv.routes.errors', [nvSharedServicesUtilsModule]);
